import React from 'react';
import { CancelIcon } from '../icons/cancel-icon.component';

interface IProps {
  children: React.ReactNode;
  onClose: () => void;
  isOpen: boolean;
  caption: string;
  description?: string | React.ReactNode;
}
export const PopupContainer = ({
  children,
  isOpen,
  onClose,
  caption,
  description
}: IProps) => {
  return (
    <div
      className={`${
        isOpen ? '' : 'hidden'
      } fixed top-0 w-screen h-screen left-0 z-50 flex align-middle justify-center flex-col `}
    >
      <div
        className="w-screen h-screen backdrop-blur-[6px] bg-black/40 absolute"
        onClick={onClose}
      />
      <div className="bg-surface-base border border-surface-hover md:rounded-[42px] shadow-[0px_4px_10px_rgba(42,60,68,0.08)] p-[32px] flex flex-col relative md:mx-auto w-full h-full md:h-auto md:w-[456px]">
        <div>
          <h1 className="text-base-black text-left font-display text-[24px] font-medium ">
            {caption}
          </h1>
          {description && (
            <div className="text-gray-700 text-lg text-center">{description}</div>
          )}
        </div>
        {children}
        <div
          onClick={onClose}
          className="absolute right-[32px] top-[35px] cursor-pointer text-content-primary-alt"
        >
          <CancelIcon />
        </div>
      </div>
    </div>
  );
};
